import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Button, Stack, Typography } from '@mui/material'
import React, { useContext } from 'react'
import { CookieContext } from 'src/Libs/cookies'

/**
 * Component used to display that the google agreement is not accepted and to open the cookie banner if
 * user wants to accept cookies.
 */
const GoogleAgreement: React.VFC = () => {
  const { t } = useCustomTranslation()
  const cookieContext = useContext(CookieContext)

  const handleShowCookies = (): void => {
    if (cookieContext?.displayCookieBanner === 'visible') {
      cookieContext.setDisplayCookieBanner('hidden')
    } else {
      cookieContext?.setDisplayCookieBanner('visible')
    }
  }

  return (
    <Stack spacing={2}>
      <Typography>{t('administration.companyManagement.showroom.google-not-agreed-text')}</Typography>
      <Button onClick={handleShowCookies}>{t('administration.companyManagement.showroom.agree-google-button-text')}</Button>
    </Stack>
  )
}

export default GoogleAgreement
